import React, {Component} from 'react';
import axios from 'axios';
import Container from 'react-bootstrap/Container';
import {withRouter} from 'react-router-dom';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";
import Spinner from "react-bootstrap/Spinner";

import classes from './GameDetails.module.css';
import {InfoOutlined} from "@material-ui/icons";
import placeholderImage from "../../assets/images/placeholder-img-3.png";

import YoutubeScript from "../UI/YoutubeScript/YoutubeScript";
import apiUrl from "../../shared/config";
import ImplementedPattern from "../ImplementedPattern/ImplementedPattern";
import {Helmet} from "react-helmet";
import ImageWithFallback from "../UI/ImageWithFallback/ImageWithFallback";
import UserButton from "../UI/UserButton/UserButton";
import {formatParagraphs} from "../../utils/utils";
import ResizableIframe from "../UI/ResizableIframe/ResizableIFrame";
import IFrameWrapper from "../UI/IFrameWrapper/IFrameWrapper";

class GameDetails extends Component {

    state = {
        game: null,
        displayed_game_implemented_patterns: []
    };

    componentDidMount() {
        // console.log('ID: ', this.props.id);
        if (this.props.id && (!this.props.urlId || this.props.id === this.props.urlId)) {
            // When the GameDetails mount, only fetch the game if the props contains an id, and either the URL
            // doesn't contain an id or the URL contains the same id as the selected id. Otherwise, fetching the
            // game will be handled on update
            axios.get(apiUrl +'Games/getGameById?game_id=' + this.props.id + (this.props.token ?  '&token=' + this.props.token : ''))
                .then(response => {
                    this.setState({game: response.data, displayed_game_implemented_patterns: response.data.game_implemented_patterns.slice(0, Math.min(10, response.data.game_implemented_patterns.length))});
                    window.scrollTo({
                        top: document.getElementById('game-details').offsetTop,
                        behavior: 'smooth'
                    })
                });
        }
        else if (this.state.game && this.props.id === null) {
            this.setState({game: null, game_implemented_patterns: []});
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {

        if (this.props.id  && this.props.id !== prevProps.id) {
            if (!this.state.game || (this.state.game && this.state.game.game_id !== this.props.id)) {
                // console.log('ID: ', this.props.id, 'GAME: ', this.state.game);
                axios.get(apiUrl +'Games/getGameById?game_id=' + this.props.id + (this.props.token ?  '&token=' + this.props.token : ''))
                    .then(response => {
                        this.setState({game: response.data, displayed_game_implemented_patterns: response.data.game_implemented_patterns.slice(0, Math.min(10, response.data.game_implemented_patterns.length))});
                        window.scrollTo({
                            top: document.getElementById('game-details').offsetTop,
                            behavior: 'smooth'
                        })
                    });
            }
        }
        else if (this.state.game && this.props.id === null) {
            this.setState({game: null});
        }
    }

    // should need to pass token for auth
    deletePostHandler = () => {
        axios.get(apiUrl +'Games/delete?game_id=' + this.props.id + "&token="+ this.props.token)
            .then(response => {
                this.props.closeGameDetails(null);
                this.props.gameSelected(null);
                console.log("Delete Success")
            }).catch(() => console.log("Delete Failed"));
    };

    editGameHandler = (selectedGameId) => {
        this.props.editGame(selectedGameId);
        this.props.closeGameDetails(null);
    };

    render () {
        let game = <div className="d-flex justify-content-sm-center">
            <div className="alert alert-secondary text-center select-alert" role="alert">
                Please select a Game to view.
            </div>
        </div>;
        if (this.props.id && !this.state.pattern && this.state.gameDetailsOpen) {
            game = <div className="d-flex justify-content-sm-center loading-alert">
                <Button variant="primary" disabled>
                    <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                    />
                    <span> Loading...</span>
                </Button>{' '}
            </div>;
        }

        if (this.state.game && this.props.gameDetailsOpen) {
            let available_link_count = 0;
            const game_available_links = this.state.game.game_available_links.map((game_available_link) => {
                available_link_count++;
                return (
                    <React.Fragment key={available_link_count}>
                        <dd className="col-xl-8"><a href={game_available_link.game_available_link} rel="noopener noreferrer" target="_blank">{game_available_link.game_available_link_source}</a>
                            <OverlayTrigger
                                trigger={['hover', 'focus']}
                                rootClose
                                rootCloseEvent="click"
                                key={"available_link_"+available_link_count}
                                placement='top'
                                overlay={
                                    <Popover id='game-deleloper-description'>
                                        <Popover.Title as="h3">Game Available Link Notes</Popover.Title>
                                        <Popover.Content className="game-description">
                                            {game_available_link.game_available_link_notes}
                                        </Popover.Content>
                                    </Popover>
                                }
                            >
                                <InfoOutlined className={"new-info-icon"}/>
                            </OverlayTrigger>
                        </dd>
                        <dt className="col-xl-4"> </dt>
                    </React.Fragment>
                )
            });

            const game_available_links_wrapper = () => {
                let available_links = '';
                if (this.state.game.game_available_links.length > 0) {
                    available_links = (<React.Fragment key="available-links">
                        <dt className="col-xl-4">Available through:</dt>
                        {game_available_links}
                    </React.Fragment>);
                }

                return available_links;
            };

            let info_link_count = 0;
            const game_info_links = this.state.game.game_info_links.map((game_info_link) => {
                info_link_count++;
                return (
                    <React.Fragment key={info_link_count}>
                        <dd className="col-xl-8"><a href={game_info_link.game_info_link} rel="noopener noreferrer" target="_blank">{game_info_link.game_info_link_source}</a>
                            <OverlayTrigger
                                trigger={['hover', 'focus']}
                                rootClose
                                rootCloseEvent="click"
                                key={"info_link_"+info_link_count}
                                placement='top'
                                overlay={
                                    <Popover id='game-deleloper-description'>
                                        <Popover.Title as="h3">Game Information Link Notes</Popover.Title>
                                        <Popover.Content className="game-description">
                                            {game_info_link.game_info_link_notes}
                                        </Popover.Content>
                                    </Popover>
                                }
                            >
                                <InfoOutlined className={"new-info-icon"}/>
                            </OverlayTrigger>
                        </dd>
                        <dt className="col-xl-4"> </dt>
                    </React.Fragment>
                )
            });

            const game_info_links_wrapper = () => {
                let info_links = '';
                if (this.state.game.game_info_links.length > 0) {
                    info_links = (<React.Fragment key="info-links">
                        <dt className="col-xl-4">More Information:</dt>
                        {game_info_links}
                    </React.Fragment>);
                }

                return info_links;
            };

            const game_developers = this.state.game.game_developers.map((game_developer) => {
                return (
                    <React.Fragment key={"dev_"+game_developer.game_developer_id}>
                        <dd className="col-xl-8">{game_developer.game_developer_name}
                            <OverlayTrigger
                                trigger={['hover', 'focus']}
                                rootClose
                                rootCloseEvent="click"
                                key={game_developer.game_developer_id}
                                placement='top'
                                overlay={
                                    <Popover id='game-deleloper-description'>
                                        <Popover.Title as="h3">{game_developer.game_developer_name}</Popover.Title>
                                        <Popover.Content className="game-description">
                                            {game_developer.game_developer_notes}
                                        </Popover.Content>
                                    </Popover>
                                }
                            >
                                <InfoOutlined className={"new-info-icon"}/>
                            </OverlayTrigger>
                        </dd>
                        <dt className="col-xl-4"> </dt>
                    </React.Fragment>
                )
            });

            const game_developers_wrapper = () => {
                let developers = '';
                if (this.state.game.game_developers.length > 0) {
                    developers = (<React.Fragment key="game-developers">
                        <dt className="col-xl-4">Developer(s):</dt>
                        {game_developers}
                    </React.Fragment>);
                }

                return developers;
            };

            const game_publishers = this.state.game.game_publishers.map((game_publisher) => {
                return (
                    <React.Fragment key={"pub_"+game_publisher.game_publisher_id}>
                        <dd className="col-xl-8">{game_publisher.game_publisher_name}
                            <OverlayTrigger
                                trigger={['hover', 'focus']}
                                rootClose
                                rootCloseEvent="click"
                                key={game_publisher.game_publisher_id}
                                placement='top'
                                overlay={
                                    <Popover id='game-description'>
                                        <Popover.Title as="h3">{game_publisher.game_publisher_name}</Popover.Title>
                                        <Popover.Content className="game-description">
                                            {game_publisher.game_publisher_notes}
                                        </Popover.Content>
                                    </Popover>
                                }
                            >
                                <InfoOutlined className={"new-info-icon"}/>
                            </OverlayTrigger>
                        </dd>
                        <dt className="col-xl-4"> </dt>
                    </React.Fragment>
                )
            });

            const game_publishers_wrapper = () => {
                let publishers = '';
                if (this.state.game.game_publishers.length > 0) {
                    publishers = (<React.Fragment key="game-publishers">
                        <dt className="col-xl-4">Publisher(s):</dt>
                        {game_publishers}
                    </React.Fragment>);
                }

                return publishers;
            };


            const game_platforms = this.state.game.game_platforms.map(game_platform =>  {
                return (
                    <React.Fragment key={"plt"+game_platform.game_platform_id}>
                        <dd className="col-xl-8">{game_platform.game_platform_short_name}
                            <OverlayTrigger
                                trigger={['hover', 'focus']}
                                rootClose
                                rootCloseEvent="click"
                                key={game_platform.game_platform_id}
                                placement='top'
                                overlay={
                                    <Popover id='game-platform-description'>
                                        <Popover.Title as="h3">{game_platform.game_platform_name}</Popover.Title>
                                        <Popover.Content className="game-description">
                                            {game_platform.game_platform_notes}
                                        </Popover.Content>
                                    </Popover>
                                }
                            >
                                <InfoOutlined className={"new-info-icon"}/>
                            </OverlayTrigger>
                        </dd>
                    <dt className="col-xl-4"> </dt>
                    </React.Fragment>
                )});

            const game_platforms_wrapper = () => {
                let releases = '';
                if (this.state.game.game_platforms.length > 0) {
                    releases = (<React.Fragment key="game-platforms">
                        <dt className="col-xl-4">Platform(s):</dt>
                        {game_platforms}
                    </React.Fragment>);
                }

                return releases
            };

            const game_types = this.state.game.game_types.map(game_type =>  {
                return (
                    <React.Fragment key={"type_"+game_type.game_type_id}>
                        <dd className="col-xl-8">{game_type.game_type_name}
                            <OverlayTrigger
                                trigger={['hover', 'focus']}
                                rootClose
                                rootCloseEvent="click"
                                key={game_type.game_type_id}
                                placement='top'
                                overlay={
                                    <Popover id='game-platform-description'>
                                        <Popover.Title as="h3">{game_type.game_type_name}</Popover.Title>
                                        <Popover.Content className="game-description">
                                            {game_type.game_type_notes}
                                        </Popover.Content>
                                    </Popover>
                                }
                            >
                                <InfoOutlined className={"new-info-icon"}/>
                            </OverlayTrigger>
                        </dd>
                        <dt className="col-xl-4"> </dt>
                    </React.Fragment>
                )});

            const game_types_wrapper = () => {
                let releases = '';
                if (this.state.game.game_types.length > 0) {
                    releases = (<React.Fragment key="game-types">
                        <dt className="col-xl-4">Game Type(s):</dt>
                        {game_types}
                    </React.Fragment>);
                }

                return releases
            };

            const game_releases = this.state.game.game_releases.map(game_release =>  {
                return (
                    <React.Fragment key={"rel_"+game_release.game_release_id}>
                        <dd className="col-xl-8">{game_release.game_release_type} - {new Date(game_release.game_release_date).getFullYear()}
                            <OverlayTrigger
                                trigger={['hover', 'focus']}
                                rootClose
                                rootCloseEvent="click"
                                key={game_release.game_release_id}
                                placement='top'
                                overlay={
                                    <Popover id='game-platform-description'>
                                        <Popover.Title as="h3">{game_release.game_release_name}</Popover.Title>
                                        <Popover.Content className="game-description">
                                            {game_release.game_release_notes}
                                        </Popover.Content>
                                    </Popover>
                                }
                            >
                                    <InfoOutlined className={"new-info-icon"}/>
                            </OverlayTrigger>
                        </dd>
                        <dt className="col-xl-4"> </dt>
                    </React.Fragment>
                )});

            const game_releases_wrapper = () => {
                let releases = '';
                if (this.state.game.game_releases.length > 0) {
                    releases = (<React.Fragment key="game-releases">
                        <dt className="col-xl-4">Game Release(s):</dt>
                        {game_releases}
                    </React.Fragment>);
                }

                return releases
            };

            const game_submitter = <dd className={"col-xl-8 " + classes.userButtonMargin}><OverlayTrigger
                trigger={['hover', 'focus']}
                rootClose
                rootCloseEvent="click"
                key={this.state.game.user_id + "SubmitterInfo"}
                placement='top'
                overlay={
                    <Popover id='game-platform-description'>
                        <Popover.Title as="h3">Submitted By</Popover.Title>
                        <Popover.Content className="game-description">
                            The submitter is the user that added this game to the Games Reference Library.
                        </Popover.Content>
                    </Popover>
                }
            >
                <InfoOutlined className={"new-info-icon"}/>
            </OverlayTrigger>
                <UserButton key={"Submitter: " + this.state.game.user_id} userId={this.state.game.user_id}/>
            </dd>

            const game_submitter_wrapper = () => {
                return this.state.game.valid_name &&  <>
                <dt className={"col-xl-4"}>Submitted By:</dt>
                {game_submitter}
                </>
            }

            let video_trailer = '';
            if(this.state.game.video_trailer !== '' && this.state.game.video_trailer !== null) {
                video_trailer = (<YoutubeScript key={this.state.game.video_trailer} id={this.state.game.video_trailer} videoType="Game Trailer"/>);
            }

            let gameplay_trailer = '';
            if(this.state.game.video_gameplay !== '' && this.state.game.video_gameplay !== null) {
                gameplay_trailer = (<YoutubeScript key={this.state.game.video_gameplay} id={this.state.game.video_gameplay} videoType="Gameplay Video"/>);
            }

            const implemented_patterns = this.state.displayed_game_implemented_patterns.map(implemented_pattern => {
                return (
                    <React.Fragment key={implemented_pattern.pattern_id + "ImplementedPattern"}>
                        <ImplementedPattern implemented_pattern={implemented_pattern}
                        patternSelected={this.props.patternSelected}
                        gameName={this.state.game.game_name}/>
                    </React.Fragment>
                )
            });

            let implemented_patterns_count = this.state.game.implemented_patterns_count;
            let hidden_implemented_patterns_count = this.state.game.implemented_patterns_count
                - this.state.game.game_implemented_patterns.length;

            const implemented_patterns_display = (
                <div className="card">
                    <h3 className="card-header">Implements {implemented_patterns_count} pattern{implemented_patterns_count === 1 ? '' : 's'}.
                        {hidden_implemented_patterns_count ? (<span> ({hidden_implemented_patterns_count} {hidden_implemented_patterns_count === 1 ? 'is' : 'are'} private and not shown)</span>) : ""}
                    </h3>
                    <div className="card-body">
                        <div className="card-text">
                            {implemented_patterns}
                            <div style={{textAlign: 'center'}}>{this.state.game.game_implemented_patterns.length > this.state.displayed_game_implemented_patterns.length
                                ? <Button
                                    variant='link'
                                    style={{fontSize: 18, alignSelf: 'center'}}
                                    onClick={() => this.setState({displayed_game_implemented_patterns: this.state.game.game_implemented_patterns})}
                                >
                                    Show All
                                </Button>
                                : ''}
                            </div>
                        </div>
                    </div>
                </div>
            );

            let admin_controls = (
                <Col>
                    <div className="delete-pattern">
                        <Button variant="outline-danger" size="sm" onClick={this.deletePostHandler}
                                className="delete-pattern-button">Delete Game</Button>
                    </div>
                </Col>);
            admin_controls = ((this.props.permissions && +this.props.permissions.delete_games === 1) ? admin_controls : <Col>
                <div className="delete-pattern"></div>
            </Col>);

            let edit_controls = (
                <Col>
                    <div className="edit-pattern">
                        <Button variant="outline-primary" size="sm" onClick={() => this.editGameHandler(this.state.game.game_id)} className="edit-pattern-button">Edit Game</Button>
                    </div>
                </Col>
            );
            edit_controls = ((this.props.isAuthenticated) ? edit_controls : <Col><div className="edit-pattern"> </div></Col>);


            let access_controls = (
                <Row>
                    {edit_controls}
                    {admin_controls}
                </Row>
            );

            let game_image = this.state.game.game_image;
            if(game_image === '' || game_image === null) {game_image = placeholderImage;
            }

            const shareText = 'Pattern Language for Game Design — Games Reference: ' + this.state.game.game_name;

            const site = String(game_image).replace("http://", '').replace("https://", '').split('/');
            game = (
                <div className="card pattern-details">
                    <Helmet>
                        <title>{shareText}</title>
                    </Helmet>
                    <h1 className="card-header">{this.state.game.game_name}</h1>
                    <div className="card-body">
                        <div className="card-text">
                            <Container>
                                <Row className={classes.description}>
                                    <Col className="col-xl-6">
                                        <a href={game_image} target="new">
                                            <ImageWithFallback className={"align-self-center col-sm-12 "} src={game_image}  alt={"Image from: "+game_image} fallbackSrc={placeholderImage} />
                                        </a>
                                        <div className={"align-self-center " + classes.truncate}>
                                            <a className={classes.ImageCaption} href={game_image} target="new">
                                                {"Image from: "+ site[0]}
                                            </a>
                                            </div>
                                    </Col>
                                    <Col className="col-xl-6" style={{whiteSpace: "pre-wrap"}}>
                                        {formatParagraphs(this.state.game.game_description)}
                                    </Col>
                                </Row>
                                {this.state.game.game_embed_links.game_embed && this.state.game.game_embed_links.game_embed.length > 0 &&
                                    <Row className={classes.description} style={{
                                        display: "flex",
                                        justifyContent: "center", // centers the iframe horizontally
                                        alignItems: "center", // vertically centers the iframe
                                        textAlign: "center",  // centers the text content
                                        flexDirection: "column", // ensures the iframe and link are stacked vertically
                                        gap: "10px",
                                        marginBottom: "20px",
                                    }} key={"embedded game"}>
                                        <h3>{this.state.game.game_embed_links.game_embed[0].game_name || "Untitled Game"}</h3>
                                        <ResizableIframe title={this.state.game.game_embed_links.game_embed[0].game_name}
                                                         src={this.state.game.game_embed_links.game_embed[0].game_embed_link}
                                                         failContent="Embeded Game Failed to Load"/>
                                </Row>}
                                <Row>
                                    {this.state.game.game_embed_links.itch_embed && this.state.game.game_embed_links.itch_embed.length > 0 &&
                                        <h3 style={{textAlign: "left", paddingLeft: "35px"}}>Additional Versions:</h3>}
                                </Row>
                                {this.state.game.game_embed_links.itch_embed && this.state.game.game_embed_links.itch_embed.map( (game_l, index) =>
                                    <Row className={this.state.game.game_embed_links.itch_embed.length === index + 1 && classes.description}
                                         style={{
                                            display: "flex",
                                            justifyContent: "center", // centers the iframe horizontally
                                            alignItems: "center", // vertically centers the iframe
                                            textAlign: "center",  // centers the text content
                                            flexDirection: "column", // ensures the iframe and link are stacked vertically
                                            gap: "10px",
                                            marginBottom: "20px",
                                    }} key={"embedded game: " + index}>
                                        <div style={{maxWidth: 1024, width: "95%", alignItems: "center"}}>
                                            <IFrameWrapper width={"100%"} height={"100%"} src={game_l.game_embed_link + "?border_width=0"} failContent="Itch Link Failed to Load" embedItchPage={true}/>
                                        </div>
                                    </Row>)}
                                <Row>
                                    <Col className="col-lg-6 col-xl-6">
                                        <dl className="row">
                                            {game_available_links_wrapper()}
                                        </dl>
                                    </Col>
                                    <Col className="col-lg-6 col-xl-6">
                                        <dl className="row">
                                            {game_info_links_wrapper()}
                                        </dl>
                                    </Col>
                                    <Col className="col-lg-6 col-xl-6">
                                        <dl className="row">
                                            {game_developers_wrapper()}
                                        </dl>
                                    </Col>
                                    <Col className="col-lg-6 col-xl-6">
                                        <dl className="row">
                                            {game_publishers_wrapper()}
                                        </dl>
                                    </Col>
                                    <Col className="col-lg-6 col-xl-6">
                                        <dl className="row">
                                            {game_types_wrapper()}
                                        </dl>
                                    </Col>
                                    <Col className="col-lg-6 col-xl-6">
                                        <dl className="row">
                                            {game_platforms_wrapper()}
                                        </dl>
                                    </Col>
                                    <Col className="col-lg-6 col-xl-6">
                                        <dl className="row">
                                            {game_releases_wrapper()}
                                        </dl>
                                    </Col>
                                    <Col className="col-lg-6 col-xl-6">
                                        <dl className="row">
                                            {game_submitter_wrapper()}
                                        </dl>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col className="col-lg-6 col-xl-6">
                                        {video_trailer}
                                    </Col>
                                    <Col className="col-lg-6 col-xl-6">
                                        {gameplay_trailer}
                                    </Col>
                                </Row>
                                <Row>
                                    <Col className="col-sm">
                                        {implemented_patterns_display}
                                    </Col>
                                </Row>
                                <br />
                                {access_controls}
                            </Container>
                        </div>
                    </div>
                </div>
            );
        }

        return game;
    }
}

export default withRouter(GameDetails);